export enum DataPrivacyRoutePathsEnum {
  DATA_PRIVACY = 'data-privacy',
}
